// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"b07c6fce","351":"0c23f834","453":"1407b060","506":"a40851db","509":"bb207dfb","585":"fa5a511a","629":"fe4bd656","752":"2dd0f8e5","931":"7adf5efb","935":"5dd6a8cf"}[chunkId] + ".chunk.js";
};